import React, { useState, useEffect } from 'react';
import {
  Container,
  Typography,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Box,
  TextField,
  InputAdornment
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import SearchIcon from '@mui/icons-material/Search';
import AddCarDialog from './AddCarDialog';
import EditCarDialog from './EditCarDialog';
import axios from 'axios';

const Cars = () => {
  const [cars, setCars] = useState([]);
  const [openAdd, setOpenAdd] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [selectedCar, setSelectedCar] = useState(null);
  const [search, setSearch] = useState('');

  const fetchCars = React.useCallback(async () => {
    try {
      const encodedSearch = encodeURIComponent(search);
      const response = await axios.get(`http://localhost:5000/api/cars${search ? `?search=${encodedSearch}` : ''}`);
      setCars(response.data);
    } catch (error) {
      console.error('Error fetching cars:', error);
    }
  }, [search]);
  
  useEffect(() => {
    fetchCars();
  }, [fetchCars]);
  
  const handleSearchChange = (e) => {
    setSearch(e.target.value);
  };

  const handleAddCar = async (carData) => {
    try {
      await axios.post('http://localhost:5000/api/cars', carData);
      fetchCars();
      setOpenAdd(false);
    } catch (error) {
      console.error('Error adding car:', error);
      throw error;
    }
  };

  const handleEditCar = async (carData) => {
    try {
      await axios.put(`http://localhost:5000/api/cars/${selectedCar._id}`, carData);
      fetchCars();
      setOpenEdit(false);
      setSelectedCar(null);
    } catch (error) {
      console.error('Error updating car:', error);
      throw error;
    }
  };

  const handleDeleteCar = async (id) => {
    if (window.confirm('Are you sure you want to delete this car?')) {
      try {
        await axios.delete(`http://localhost:5000/api/cars/${id}`);
        fetchCars();
      } catch (error) {
        console.error('Error deleting car:', error);
      }
    }
  };

  return (
    <Container maxWidth="lg" sx={{ mt: 4 }}>
      <Typography variant="h4" component="h1" sx={{ mb: 3 }}>
        Available Cars
      </Typography>

      <Box sx={{ display: 'flex', gap: 2, mb: 3 }}>
        <TextField
          variant="outlined"
          placeholder="Search cars..."
          value={search}
          onChange={handleSearchChange}
          sx={{ flexGrow: 1 }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
        <Button 
          variant="contained" 
          onClick={() => setOpenAdd(true)}
        >
          Add New Car
        </Button>
      </Box>

      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Unit Number</TableCell>
              <TableCell>Make</TableCell>
              <TableCell>Model</TableCell>
              <TableCell>Year</TableCell>
              <TableCell>KIR Exp. Date</TableCell>
              <TableCell>STNK Exp. Date</TableCell>
              <TableCell>License Plate Exp. Date</TableCell>
              <TableCell>Regional Plate</TableCell>
              <TableCell>Owner Name</TableCell>
              <TableCell>Body Color</TableCell>
              <TableCell>MyPertamina Code</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {cars.map((car) => (
              <TableRow key={car._id}>
                <TableCell>{car.unitNumber}</TableCell>
                <TableCell>{car.make}</TableCell>
                <TableCell>{car.model}</TableCell>
                <TableCell>{car.year}</TableCell>
                <TableCell>{new Date(car.kirExpDate).toLocaleDateString()}</TableCell>
                <TableCell>{new Date(car.stnkExpDate).toLocaleDateString()}</TableCell>
                <TableCell>{new Date(car.licensePlateExpDate).toLocaleDateString()}</TableCell>
                <TableCell>{car.regionalPlate}</TableCell>
                <TableCell>{car.ownerName}</TableCell>
                <TableCell>{car.bodyColor}</TableCell>
                <TableCell>{car.myPertaminaCode}</TableCell>
                <TableCell>
                  <IconButton 
                    onClick={() => {
                      setSelectedCar(car);
                      setOpenEdit(true);
                    }}
                    color="primary"
                  >
                    <EditIcon />
                  </IconButton>
                  <IconButton 
                    onClick={() => handleDeleteCar(car._id)}
                    color="error"
                  >
                    <DeleteIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <AddCarDialog
        open={openAdd}
        onClose={() => setOpenAdd(false)}
        onAdd={handleAddCar}
      />

      {selectedCar && (
        <EditCarDialog
          open={openEdit}
          onClose={() => {
            setOpenEdit(false);
            setSelectedCar(null);
          }}
          onEdit={handleEditCar}
          car={selectedCar}
        />
      )}
    </Container>
  );
};

export default Cars;